<template>
  <div v-if="currentUser.is_admin" class="institution-settings">
    <v-row>
      <v-col offset-md="2" cols="12" md="8">
        <div class="mx-3">
          <h1 class="text-left">Settings</h1>
          <v-divider class="my-2"></v-divider>
          <div class="mb-4" v-for="settingGroup in settings" :key="settingGroup.id">
            <h3 class="text-left">{{ settingGroup.name }}</h3>
            <v-card class="py-0" elevation="1">
              <v-list class="mt-2" color="#FAFAFA">
                <div v-for="child in settingGroup.children" :key="child.title">

                <v-list-item
                  class="py-2"
                  :to="{ name: child.link }"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ child.title }}</v-list-item-title>
                    <v-list-item-subtitle
                      >{{ child.description }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="settingGroup.children.indexOf(child) != settingGroup.children.length - 1" ></v-divider>
                </div>
              </v-list>
            </v-card>
          </div>
          <!-- <div>
            <h3 class="text-left">Other Settings</h3>
            <v-card class="py-0" elevation="1">
              <v-list class="mt-2" color="#FAFAFA">
                <v-list-item
                  class="py-2"
                  :to="{ name: 'FeeSettings' }"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>Fee Settings</v-list-item-title>
                    <v-list-item-subtitle
                      >Fee Categories, Schedules, Particulars, Structure,
                      etc.</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                  :to="{ name: 'InventorySettings' }"
                  class="py-2"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>Inventory Settings</v-list-item-title>
                    <v-list-item-subtitle
                      >Manage Store Categories, Types, Suppliers,
                      etc.</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                  :to="{ name: 'StaffAttendanceSettings' }"
                  class="py-2"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title
                      >Staff Attendance Settings</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >Manage Staff Categories, HR Accounts,
                      etc.</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                  :to="{ name: 'PayrollSettings' }"
                  class="py-2"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>Payroll Settings</v-list-item-title>
                    <v-list-item-subtitle
                      >Manage Salaries and Payslips of all
                      employees</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                  :to="{ name: 'FinanceSettings' }"
                  class="py-2"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>Finance Settings</v-list-item-title>
                    <v-list-item-subtitle
                      >Manage Finance Categories, Income and Expense
                      Records</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </div> -->
        </div>
      </v-col>
    </v-row>

    <!-- <v-fab-transition>
      <v-btn
        @click="showTutorialResetConfirmationDialog = true"
        fab
        dark
        color="primary"
        fixed
        right
        bottom
      >
        <v-icon dark>mdi-help</v-icon>
      </v-btn>
    </v-fab-transition>
    <ConfirmationDialog
      :visible="showTutorialResetConfirmationDialog"
      title="Are you sure you want to reset the ERP tutorial?"
      description="This will enable walkthrough and tutorials throughout the ERP."
      successText="RESET"
      failureText="Cancel"
      @successCallback="resetTour"
      @failureCallback="showTutorialResetConfirmationDialog = false"
    /> -->
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import ConfirmationDialog from "@components/widgets/dialogs/ConfirmationDialog";
export default {
  components: {
    // ConfirmationDialog: ConfirmationDialog,
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  name: "InstitutionSettings",
  data() {
    return {
      showTutorialResetConfirmationDialog: false,
      settings: [
        {
          name: 'Institution Settings', 
          id: 1,
          children: [
            {
              title: 'Institution Details',
              description: 'Institution Logo, Name, Address, etc.',
              link: 'InstitutionDetailsSettings',
            },
            {
              title: 'Staff Roles & Permissions',
              description: 'Manage Staff Roles, Permissions, Access, etc.',
              link: 'PermissionSettings'
            },
            {
              title: 'User Document Types',
              description: 'Manage Student, Staff and Admission Document types.',
              link: 'UserDocumentTypes'
            },
            {
              title: 'User Attributes',
              description: 'Manage custom attributes for Students and Staff.',
              link: 'UserAttributes'
            }
          ]
        },
        {
          name: 'Other Settings', 
          id: 2, 
          children: [
            {
              title: 'Fee Settings',
              description: 'Fee Categories, Schedules, Particulars, Structure, etc.',
              link: 'FeeSettings'
            },
            {
              title: 'Finance Settings',
              description: 'Manage Finance Categories and Income Receipt Settings',
              link: 'FinanceSettings'
            },
            {
              title: 'Staff Attendance Settings',
              description: 'Manage Staff Categories, HR Accounts, etc.',
              link: 'StaffAttendanceSettings'
            },
            {
              title: 'Payroll Settings',
              description: 'Manage Payroll Particulars, Groups and Payslip Settings',
              link: 'PayrollSettings'
            },
            {
              title: 'Inventory Settings',
              description: 'Manage Store Categories, Types, Suppliers, etc.',
              link: 'InventorySettings'
            },
          ]
        },
        {
          name: 'Recycle Bin', 
          id: 3,
          children: [
            {
              title: 'Deleted Student Accounts',
              description: 'Restore or Permanently Delete Student Accounts',
              link: 'DeletedStudents',
            },
            {
              title: 'Deleted Student Classroom Records',
              description: 'Restore Students with deleted classroom records.',
              link: 'DeletedCurrentRecords',
            },
            {
              title: 'Deleted Staff Accounts',
              description: 'Restore or Permanently Delete Staff Accounts',
              link: 'DeletedStaff'
            }
          ]
        },
      ],

      snackbar: {
        text: "",
        visible: false,
      },
    };
  },
  methods: {
    ...mapActions(["resetTourHistory"]),

    async resetTour() {
      this.resetTourHistory();
      this.showTutorialResetConfirmationDialog = false;
      this.snackbar.text = "ERP Tutorials & Walkthrughs have been enabled.";
      this.snackbar.visible = true;
    },
  },
};
</script>

<style>
</style>